import React from 'react'
import { Nav } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from "react-i18next"

export default function SidebarAdmin({ isCollapsed }) {
	const { t } = useTranslation()
	const location = useLocation()

	const isActive = (path) => {
		return location.pathname.includes(path)
	}

  	return (
		<div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`} id="sidebar">
			<Link to="/">
				<img 
					src={isCollapsed ? '/images/logotipo-reducido-movil.svg' : '/images/logotipo-sdplay-cabecera.svg'} 
					id="logo-menu" 
					alt='Logotipo SDPlay' 
				/>
			</Link>
			<Nav className="flex-column p-0">
				<Nav.Item>
					<Link 
						to={`/${t("url.admin.admin")}/${t("url.admin.dashboard")}`}
						className={isActive(t("url.admin.dashboard")) ? 'active' : ''}
					>
						<img src="/images/menus/dashboard.svg" alt={t('menus.general.dashboard')}/> 
						{!isCollapsed && t('menus.general.dashboard')}
					</Link>
				</Nav.Item>
				<Nav.Item>
					<Link 
						to={`/${t("url.admin.admin")}/${t("url.admin.clubs")}`}
						className={isActive(t("url.admin.clubs")) ? 'active' : ''}
					>
						<img src="/images/menus/clubs.svg" alt={t('menus.general.clubs')}/> 
						{!isCollapsed && t('menus.general.clubs')}
					</Link>
				</Nav.Item>
				<Nav.Item>
					<Link 
						to={`/${t("url.admin.admin")}/${t("url.admin.clients")}`}
						className={isActive(t("url.admin.clients")) ? 'active' : ''}
					>
						<img src="/images/menus/members.svg" alt={t('menus.general.clients')}/> 
						{!isCollapsed && t('menus.general.clients')}
					</Link>
				</Nav.Item>
				<Nav.Item>
					<Link 
						to={`/${t("url.admin.admin")}/${t("url.admin.inscriptions")}`}
						className={isActive(t("url.admin.inscriptions")) ? 'active' : ''}
					>
						<img src="/images/menus/calendar.svg" alt={t('menus.general.inscriptions')}/> 
						{!isCollapsed && t('menus.general.inscriptions')}
					</Link>
				</Nav.Item>
				<Nav.Item>
					<Link 
						to={`/${t("url.admin.admin")}/${t("url.admin.passes")}`}
						className={isActive(t("url.admin.passes")) ? 'active' : ''}
					>
						<img src="/images/menus/pass.svg" alt={t('menus.general.passes')}/> 
						{!isCollapsed && t('menus.general.passes')}
					</Link>
				</Nav.Item>
				<Nav.Item>
					<Link 
						to={`/${t("url.admin.admin")}/${t("url.admin.tickets")}`}
						className={isActive(t("url.admin.tickets")) ? 'active' : ''}
					>
						<img src="/images/menus/ticketing.svg" alt={t('menus.general.tickets')}/> 
						{!isCollapsed && t('menus.general.tickets')}
					</Link>
				</Nav.Item>
				<Nav.Item>
					<Link 
						to={`/${t("url.admin.admin")}/${t("url.admin.payments")}`}
						className={isActive(t("url.admin.payments")) ? 'active' : ''}
					>
						<img src="/images/menus/payments.svg" alt={t('menus.general.payments')}/> 
						{!isCollapsed && t('menus.general.payments')}
					</Link>
				</Nav.Item>
				<Nav.Item>
					<Link 
						to={`/${t("url.admin.admin")}/${t("url.admin.logs")}/${t("url.admin.sepalogs")}`}
						className={isActive(t("url.admin.sepalogs")) ? 'active' : ''}
					>
						<img src="/images/menus/config.svg" alt={t('menus.general.sepalogs')}/> 
						{!isCollapsed && t('menus.general.sepalogs')}
					</Link>
				</Nav.Item>
			</Nav>
		</div>
	)
}